"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function CardHeader(props) {
  var className = props.className,
      anchorId = props.anchorId,
      title = props.title,
      subtitle = props.subtitle,
      borderless = props.borderless,
      headerComponents = props.headerComponents,
      titleClassName = props.titleClassName;
  var wrapperClassName = (0, _classnames.default)(className, 'py-5 sm:py-6 px-5 sm:px-8', {
    'md:border-b': !borderless,
    'flex flex-col lg:flex-row lg:items-center': headerComponents
  });
  var baseTitleClassName = (0, _classnames.default)('text-xl', {
    'mb-1 sm:mb-2': subtitle,
    'anchor-section': anchorId
  }, titleClassName);
  return _react.default.createElement("div", {
    className: wrapperClassName
  }, _react.default.createElement("div", {
    className: "mb-4 sm:mb-0"
  }, _react.default.createElement("h2", {
    id: anchorId,
    className: baseTitleClassName
  }, title), subtitle ? _react.default.createElement("div", {
    className: "text-xs-sm sm:text-sm"
  }, subtitle) : null), headerComponents || null);
}

CardHeader.propTypes = {
  className: _propTypes.default.string,
  anchorId: _propTypes.default.string,
  title: _propTypes.default.string.isRequired,
  subtitle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  borderless: _propTypes.default.bool,
  headerComponents: _propTypes.default.node,
  componentClassName: _propTypes.default.string,
  titleClassName: _propTypes.default.string
};
CardHeader.defaultProps = {
  className: '',
  anchorId: null,
  subtitle: null,
  borderless: false,
  headerComponents: null,
  componentClassName: '',
  titleClassName: ''
};

var _default = _react.default.memo(CardHeader);

exports.default = _default;